/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  ViewType,
  viewTypeToNumber,
  viewTypeFromJSON,
  viewTypeToJSON,
} from "../Offer/Accommodation/ViewType";

export interface AccommodationDifference {
  hasRoomChanges: boolean;
  transfer: AccommodationDifference_AccommodationStatus;
  privateTransfer: AccommodationDifference_AccommodationStatus;
  rentalCar: AccommodationDifference_AccommodationStatus;
  railAndFly: AccommodationDifference_AccommodationStatus;
  roomType: AccommodationDifference_AccommodationStatus;
  originalRoomType: AccommodationDifference_AccommodationStatus;
  mealType: AccommodationDifference_AccommodationStatus;
  view: AccommodationDifference_AccommodationStatus;
  class: AccommodationDifference_AccommodationStatus;
  pool: AccommodationDifference_AccommodationStatus;
  exterior: AccommodationDifference_AccommodationStatus;
  oldViewType: ViewType;
  roomContentIdList: string[];
}

export enum AccommodationDifference_AccommodationStatus {
  NoChange = "NoChange",
  Removed = "Removed",
  Added = "Added",
}

export function accommodationDifference_AccommodationStatusFromJSON(
  object: any
): AccommodationDifference_AccommodationStatus {
  switch (object) {
    case 0:
    case "NoChange":
      return AccommodationDifference_AccommodationStatus.NoChange;
    case 1:
    case "Removed":
      return AccommodationDifference_AccommodationStatus.Removed;
    case 2:
    case "Added":
      return AccommodationDifference_AccommodationStatus.Added;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum AccommodationDifference_AccommodationStatus"
      );
  }
}

export function accommodationDifference_AccommodationStatusToJSON(
  object: AccommodationDifference_AccommodationStatus
): string {
  switch (object) {
    case AccommodationDifference_AccommodationStatus.NoChange:
      return "NoChange";
    case AccommodationDifference_AccommodationStatus.Removed:
      return "Removed";
    case AccommodationDifference_AccommodationStatus.Added:
      return "Added";
    default:
      return "UNKNOWN";
  }
}

export function accommodationDifference_AccommodationStatusToNumber(
  object: AccommodationDifference_AccommodationStatus
): number {
  switch (object) {
    case AccommodationDifference_AccommodationStatus.NoChange:
      return 0;
    case AccommodationDifference_AccommodationStatus.Removed:
      return 1;
    case AccommodationDifference_AccommodationStatus.Added:
      return 2;
    default:
      return 0;
  }
}

function createBaseAccommodationDifference(): AccommodationDifference {
  return {
    hasRoomChanges: false,
    transfer: AccommodationDifference_AccommodationStatus.NoChange,
    privateTransfer: AccommodationDifference_AccommodationStatus.NoChange,
    rentalCar: AccommodationDifference_AccommodationStatus.NoChange,
    railAndFly: AccommodationDifference_AccommodationStatus.NoChange,
    roomType: AccommodationDifference_AccommodationStatus.NoChange,
    originalRoomType: AccommodationDifference_AccommodationStatus.NoChange,
    mealType: AccommodationDifference_AccommodationStatus.NoChange,
    view: AccommodationDifference_AccommodationStatus.NoChange,
    class: AccommodationDifference_AccommodationStatus.NoChange,
    pool: AccommodationDifference_AccommodationStatus.NoChange,
    exterior: AccommodationDifference_AccommodationStatus.NoChange,
    oldViewType: ViewType.UnknownView,
    roomContentIdList: [],
  };
}

export const AccommodationDifference = {
  encode(
    message: AccommodationDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.hasRoomChanges === true) {
      writer.uint32(112).bool(message.hasRoomChanges);
    }
    if (
      message.transfer !== AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(8)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.transfer)
        );
    }
    if (
      message.privateTransfer !==
      AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(16)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(
            message.privateTransfer
          )
        );
    }
    if (
      message.rentalCar !== AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(24)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.rentalCar)
        );
    }
    if (
      message.railAndFly !==
      AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(32)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(
            message.railAndFly
          )
        );
    }
    if (
      message.roomType !== AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(40)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.roomType)
        );
    }
    if (
      message.originalRoomType !==
      AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(48)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(
            message.originalRoomType
          )
        );
    }
    if (
      message.mealType !== AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(56)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.mealType)
        );
    }
    if (message.view !== AccommodationDifference_AccommodationStatus.NoChange) {
      writer
        .uint32(80)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.view)
        );
    }
    if (
      message.class !== AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(88)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.class)
        );
    }
    if (message.pool !== AccommodationDifference_AccommodationStatus.NoChange) {
      writer
        .uint32(96)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.pool)
        );
    }
    if (
      message.exterior !== AccommodationDifference_AccommodationStatus.NoChange
    ) {
      writer
        .uint32(104)
        .int32(
          accommodationDifference_AccommodationStatusToNumber(message.exterior)
        );
    }
    if (message.oldViewType !== ViewType.UnknownView) {
      writer.uint32(64).int32(viewTypeToNumber(message.oldViewType));
    }
    for (const v of message.roomContentIdList) {
      writer.uint32(122).string(v!);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 14:
          message.hasRoomChanges = reader.bool();
          break;
        case 1:
          message.transfer =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 2:
          message.privateTransfer =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 3:
          message.rentalCar =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 4:
          message.railAndFly =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 5:
          message.roomType =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 6:
          message.originalRoomType =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 7:
          message.mealType =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 10:
          message.view = accommodationDifference_AccommodationStatusFromJSON(
            reader.int32()
          );
          break;
        case 11:
          message.class = accommodationDifference_AccommodationStatusFromJSON(
            reader.int32()
          );
          break;
        case 12:
          message.pool = accommodationDifference_AccommodationStatusFromJSON(
            reader.int32()
          );
          break;
        case 13:
          message.exterior =
            accommodationDifference_AccommodationStatusFromJSON(reader.int32());
          break;
        case 8:
          message.oldViewType = viewTypeFromJSON(reader.int32());
          break;
        case 15:
          message.roomContentIdList.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationDifference {
    return {
      hasRoomChanges: isSet(object.hasRoomChanges)
        ? Boolean(object.hasRoomChanges)
        : false,
      transfer: isSet(object.transfer)
        ? accommodationDifference_AccommodationStatusFromJSON(object.transfer)
        : AccommodationDifference_AccommodationStatus.NoChange,
      privateTransfer: isSet(object.privateTransfer)
        ? accommodationDifference_AccommodationStatusFromJSON(
            object.privateTransfer
          )
        : AccommodationDifference_AccommodationStatus.NoChange,
      rentalCar: isSet(object.rentalCar)
        ? accommodationDifference_AccommodationStatusFromJSON(object.rentalCar)
        : AccommodationDifference_AccommodationStatus.NoChange,
      railAndFly: isSet(object.railAndFly)
        ? accommodationDifference_AccommodationStatusFromJSON(object.railAndFly)
        : AccommodationDifference_AccommodationStatus.NoChange,
      roomType: isSet(object.roomType)
        ? accommodationDifference_AccommodationStatusFromJSON(object.roomType)
        : AccommodationDifference_AccommodationStatus.NoChange,
      originalRoomType: isSet(object.originalRoomType)
        ? accommodationDifference_AccommodationStatusFromJSON(
            object.originalRoomType
          )
        : AccommodationDifference_AccommodationStatus.NoChange,
      mealType: isSet(object.mealType)
        ? accommodationDifference_AccommodationStatusFromJSON(object.mealType)
        : AccommodationDifference_AccommodationStatus.NoChange,
      view: isSet(object.view)
        ? accommodationDifference_AccommodationStatusFromJSON(object.view)
        : AccommodationDifference_AccommodationStatus.NoChange,
      class: isSet(object.class)
        ? accommodationDifference_AccommodationStatusFromJSON(object.class)
        : AccommodationDifference_AccommodationStatus.NoChange,
      pool: isSet(object.pool)
        ? accommodationDifference_AccommodationStatusFromJSON(object.pool)
        : AccommodationDifference_AccommodationStatus.NoChange,
      exterior: isSet(object.exterior)
        ? accommodationDifference_AccommodationStatusFromJSON(object.exterior)
        : AccommodationDifference_AccommodationStatus.NoChange,
      oldViewType: isSet(object.oldViewType)
        ? viewTypeFromJSON(object.oldViewType)
        : ViewType.UnknownView,
      roomContentIdList: Array.isArray(object?.roomContentIdList)
        ? object.roomContentIdList.map((e: any) => String(e))
        : [],
    };
  },

  toJSON(message: AccommodationDifference): unknown {
    const obj: any = {};
    message.hasRoomChanges !== undefined &&
      (obj.hasRoomChanges = message.hasRoomChanges);
    message.transfer !== undefined &&
      (obj.transfer = accommodationDifference_AccommodationStatusToJSON(
        message.transfer
      ));
    message.privateTransfer !== undefined &&
      (obj.privateTransfer = accommodationDifference_AccommodationStatusToJSON(
        message.privateTransfer
      ));
    message.rentalCar !== undefined &&
      (obj.rentalCar = accommodationDifference_AccommodationStatusToJSON(
        message.rentalCar
      ));
    message.railAndFly !== undefined &&
      (obj.railAndFly = accommodationDifference_AccommodationStatusToJSON(
        message.railAndFly
      ));
    message.roomType !== undefined &&
      (obj.roomType = accommodationDifference_AccommodationStatusToJSON(
        message.roomType
      ));
    message.originalRoomType !== undefined &&
      (obj.originalRoomType = accommodationDifference_AccommodationStatusToJSON(
        message.originalRoomType
      ));
    message.mealType !== undefined &&
      (obj.mealType = accommodationDifference_AccommodationStatusToJSON(
        message.mealType
      ));
    message.view !== undefined &&
      (obj.view = accommodationDifference_AccommodationStatusToJSON(
        message.view
      ));
    message.class !== undefined &&
      (obj.class = accommodationDifference_AccommodationStatusToJSON(
        message.class
      ));
    message.pool !== undefined &&
      (obj.pool = accommodationDifference_AccommodationStatusToJSON(
        message.pool
      ));
    message.exterior !== undefined &&
      (obj.exterior = accommodationDifference_AccommodationStatusToJSON(
        message.exterior
      ));
    message.oldViewType !== undefined &&
      (obj.oldViewType = viewTypeToJSON(message.oldViewType));
    if (message.roomContentIdList) {
      obj.roomContentIdList = message.roomContentIdList.map((e) => e);
    } else {
      obj.roomContentIdList = [];
    }
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationDifference>
  ): AccommodationDifference {
    const message = createBaseAccommodationDifference();
    message.hasRoomChanges = object.hasRoomChanges ?? false;
    message.transfer =
      object.transfer ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.privateTransfer =
      object.privateTransfer ??
      AccommodationDifference_AccommodationStatus.NoChange;
    message.rentalCar =
      object.rentalCar ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.railAndFly =
      object.railAndFly ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.roomType =
      object.roomType ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.originalRoomType =
      object.originalRoomType ??
      AccommodationDifference_AccommodationStatus.NoChange;
    message.mealType =
      object.mealType ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.view =
      object.view ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.class =
      object.class ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.pool =
      object.pool ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.exterior =
      object.exterior ?? AccommodationDifference_AccommodationStatus.NoChange;
    message.oldViewType = object.oldViewType ?? ViewType.UnknownView;
    message.roomContentIdList = object.roomContentIdList?.map((e) => e) || [];
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
